import type { ReactNode } from "react";

import { cn } from "@synthesis/shared-utils";

type DetailFieldRowProps = {
  label?: string;
  children: ReactNode;
  className?: string;
};

export const DetailFieldRow = ({ label, children, className }: DetailFieldRowProps) => {
  if (!label) {
    return children;
  }

  return (
    <div
      className={cn(
        "border-neutrals-90 grid grid-cols-[minmax(0,14.8125rem)_minmax(0,1fr)] items-start gap-4 border-b py-3 last:border-b-0",
        className,
      )}
    >
      <p className="paragraph-base text-type-minor">{label}</p>
      <div className="paragraph-base text-type-common min-w-0">{children}</div>
    </div>
  );
};
